import { render, staticRenderFns } from "./tabDetail.vue?vue&type=template&id=eb230e3e"
import script from "./tabDetail.vue?vue&type=script&lang=js"
export * from "./tabDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports